import { aboutContent } from "./about";
import { videoContent } from "./video";
import { valoresContent } from "./valores";

export const aboutViewContent = {
  aboutContent,
  videoContent,
  valoresContent,
};
